<template>
  <div class="cutting-dock h100 hide-scrollbar">
    <div class="w100 h100 flex">
      <AnchorNav
        :getContainer="() => container"
        :navs="navs"
        prefix="cuttingDock"
      />
      <div class="wrap y-auto x-auto h100" ref="wrap">
        <div style="min-width: 1445px">
          <!-- 单双工位设置 -->
          <div class="station-setup">
            <span id="span_t3loyf90j4" class="head-title">{{
              translateLang('dock56Drill.equipment')
            }}</span>
            <span id="span_jqrkwfksus" class="second-title">{{
              translateLang('dock56Drill.equipType')
            }}</span>
            <a-radio-group
              v-model="formData.single_double_station"
              @change="handleChangeStationType"
            >
              <template v-for="item in cuttingDockStationSetup">
                <a-radio
                  class="ml20"
                  :key="item.value"
                  :value="item.value"
                  :id="`engraving_setting_station_setup_${item.value}__radio`"
                  >{{ $t(item.label) }}</a-radio
                >
              </template>
            </a-radio-group>
          </div>
          <div class="knife-table" id="knife-table">
            <span id="span_bs1yfbprcw" class="head-title">{{
              $t('common.knivesStore')
            }}</span>
            <div class="operation-btn flex flex-cross--center">
              <a-button
                @click="handleAddNewKnife"
                class="mr12"
                id="engraving_setting_knife_table_add_row"
                >{{ $t('cuttingDock.knives.insert') }}</a-button
              >
              <a-button
                @click="handleDeleteKnife"
                class="danger-btn"
                id="engraving_setting_knife_table_delete_row"
                :class="{ 'disabled-btn': formData.knives.length < 2 }"
                >{{ $t('cuttingDock.knives.delete') }}</a-button
              >
              <div id="div_fmgk2i6ujz" class="ml10 feeding-tips">
                {{ $t('cuttingDock.knives.tip') }}
              </div>
            </div>
            <div class="main-table">
              <el-table
                ref="knifeTable"
                :data="formData.knives"
                :key="tableKey"
                :row-style="changeStyle"
                :cell-style="columnStyle"
                :header-cell-style="headerStyle"
                :header-row-style="headerRowStyle"
                @row-click="choseKnife"
                :row-class-name="tableRowClassName"
                :cell-class-name="tableCellClassName"
                @cell-click="cellClick"
                :max-height="340"
                class="w100"
              >
                <el-table-column
                  v-for="(knife, indexs) in knivesColumns"
                  :key="indexs + '1'"
                  :label="translateLang(knife.label)"
                  :prop="knife.props"
                  :width="knife.width"
                  :fixed="[0, 1, 2, 3].includes(indexs)"
                >
                  <template #header>
                    <template
                      v-if="
                        knife.props === 'length' ||
                        knife.props === 'maximum_single_depth'
                      "
                    >
                      <div class="knife-header">
                        <span id="span_juag14lu4w">{{
                          translateLang(knife.label)
                        }}</span>
                        <a-tooltip :title="$translateLang('仅对内部异形生效')">
                          <a-icon type="question-circle" />
                        </a-tooltip>
                      </div>
                    </template>
                    <template v-else>
                      <span :id="knife.elementId">{{
                        translateLang(knife.label)
                      }}</span>
                    </template>
                  </template>
                  <template slot="header" v-if="knife.props == 'type'">
                    <div class="flex flex-cross--center">
                      <span id="span_9jrqb0wi46">{{
                        $translateLang('类型')
                      }}</span>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        placement="bottom-start"
                      >
                        <div id="div_8wi0y8jiuw" slot="content">
                          {{
                            $translateLang(
                              '设置刀具类型后孔槽会匹配对应类型的刀具进行加工'
                            )
                          }}
                        </div>
                        <img
                          src="@/assets/icon/questionMark.png"
                          alt=""
                          style="width: 17px; height: 17px; margin-left: 5px"
                        />
                      </el-tooltip>
                    </div>
                  </template>
                  <template slot-scope="scope">
                    <div v-if="knife.props === 'use'" class="knife-purpose">
                      <a-checkbox-group v-model="scope.row.knifePurpose">
                        <a-checkbox
                          value="holeable"
                          class="mb10 mr8"
                          :id="`engraving_setting_knife_table_${scope.row.index}_use_holeable_checkbox`"
                          :disabled="!['dill', 'mill'].includes(scope.row.type)"
                        >
                          <span
                            style="margin: 0"
                            :id="`engraving_setting_knife_table_${scope.row.index}_use_holeable_checkbox_label`"
                            >{{ $t('cuttingDock.knives.punchHoles') }}</span
                          >
                        </a-checkbox>
                        <a-checkbox
                          value="slotable"
                          :id="`engraving_setting_knife_table_${scope.row.index}_use_slotable_checkbox`"
                          :disabled="scope.row.type != 'mill'"
                        >
                          <span
                            style="margin: 0"
                            :id="`engraving_setting_knife_table_${scope.row.index}_use_slotable_checkbox_label`"
                            >{{ $t('cuttingDock.knives.pullSlots') }}</span
                          >
                        </a-checkbox>
                        <a-checkbox
                          value="millableHole"
                          class="mb10 mr8"
                          :id="`engraving_setting_knife_table_${scope.row.index}_use_millableHole_checkbox`"
                          :disabled="scope.row.type != 'mill'"
                        >
                          <span
                            style="margin: 0"
                            :id="`engraving_setting_knife_table_${scope.row.index}_use_millableHole_checkbox_label`"
                            >{{ $t('cuttingDock.knives.millHoles') }}</span
                          >
                        </a-checkbox>
                        <a-checkbox
                          value="millableSlot"
                          :id="`engraving_setting_knife_table_${scope.row.index}_use_millableSlot_checkbox`"
                          :disabled="scope.row.type != 'mill'"
                        >
                          <span
                            style="margin: 0"
                            :id="`engraving_setting_knife_table_${scope.row.index}_use_millableSlot_checkbox_label`"
                            >{{ $t('cuttingDock.knives.millSlots') }}</span
                          >
                        </a-checkbox>
                      </a-checkbox-group>
                    </div>
                    <div v-else-if="knife.props == 'cutable'">
                      <a-checkbox
                        v-model="scope.row[knife.props]"
                        @change="onlyOneChecked(scope.row)"
                        :id="`engraving_setting_knife_table_${scope.row.index}_cutable_checkbox`"
                        :disabled="scope.row.type === 'laser'"
                      ></a-checkbox>
                    </div>
                    <div v-else-if="knife.props == 'type'">
                      <a-select
                        v-model="scope.row.type"
                        :id="`engraving_setting_knife_table_${scope.row.index}_type_select`"
                        style="width: 100px"
                        @change="handleChangeKnifeType($event, scope.row)"
                      >
                        <a-select-option
                          v-for="item in knifeTypeOptionsList"
                          :key="`${item.value}_${scope.row.index}`"
                          :value="item.value"
                          :title="item.label"
                          :disabled="item.isDisabled"
                          >{{ item.label }}</a-select-option
                        >
                      </a-select>
                    </div>
                    <div
                      v-else-if="
                        scope.row.index === rowIndex &&
                        scope.column.index === columnIndex &&
                        knife.props !== 'type' &&
                        knife.props !== 'use'
                      "
                    >
                      <el-input
                        v-model="scope.row[knife.props]"
                        ref="editInput"
                        type="textarea"
                        size="mini"
                        resize="none"
                        autosize
                        :maxlength="
                          isKnifeSpeedProp(knife.props)
                            ? CUTTING_DOCK_SPEED_INPUT_MAX_LEN
                            : undefined
                        "
                        :disabled="
                          !scope.row.type.includes('obliqueDrill') &&
                          ['axis_offset', 'arc_radius'].includes(knife.props)
                        "
                        @blur="inputBlur(scope.row, knife.props)"
                        @change="inputBlur(scope.row, knife.props)"
                        @input="
                          handleInputCheck(
                            scope.row,
                            knife.props,
                            knife.isCheck
                          )
                        "
                        :id="`engraving_setting_knife_table_${scope.row.index}_${knife.props}_input`"
                      />
                    </div>
                    <div
                      class="knives_type"
                      style="white-space: pre-line"
                      v-else-if="
                        knife.props !== 'desc' &&
                        knife.props !== 'type' &&
                        knife.props !== 'use'
                      "
                      :id="`engraving_setting_knife_table_${scope.row.index}_${knife.props}`"
                    >
                      {{ scope.row[knife.props] }}
                      <span
                        :class="[
                          'iconfont',
                          'icon-revise',
                          { 'icon-revise-show': scope.row[knife.props] },
                        ]"
                        style="color: #18a8c7"
                      ></span>
                    </div>
                    <div
                      class="knives_type"
                      style="white-space: pre-line"
                      v-else
                    >
                      {{ scope.row[knife.props] }}
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <div
                v-if="laserEnable"
                class="knives_type_tip mt20 flex flex-cross--left flex-dir--top"
              >
                <span>{{
                  $translateLang('开料：用于加工内部未打穿异形')
                }}</span>
                <span>{{
                  $translateLang('激光刀：加工打穿的孔槽、内部异形、外轮廓下料')
                }}</span>
              </div>
            </div>
            <!-- 双工位换刀代码复选框 -->
            <div class="changeKnifeCodeCheckbox" v-if="showConfig">
              <span id="span_3il1fdiq6a" class="text">{{
                $t('cuttingDock.knives.doubleSaw')
              }}</span>
              <a-checkbox
                v-model="formData.open_two_station_code"
                @change="handleChangeShowCode2"
                :id="`engraving_setting_knife_table_double_saw_enable_checkbox`"
              ></a-checkbox>
            </div>
          </div>
          <div class="code-box">
            <div class="code-content">
              <!-- 雕刻机代码框 -->
              <div class="code-display">
                <div>
                  <div>
                    <div>
                      <span
                        class="head-title b"
                        style="width: auto"
                        id="code-box"
                        >{{ $t('cuttingDock.other.title') }}</span
                      ><span
                        id="span_2cqlxfxu19"
                        class="feeding-tips"
                        v-if="showConfig"
                        >（{{ $t('cuttingDock.pumpPauseTip') }}）</span
                      >
                    </div>
                    <div class="text-area">
                      <div>
                        <span id="span_unsm199mws">{{
                          $t('cuttingDock.autoStockCode1')
                        }}</span>
                        <a-textarea
                          v-model="
                            formData.autoSendStockCodeSetting.template_string
                          "
                          :placeholder="
                            $t('cuttingDock.autoStockCode1PlaceHolder')
                          "
                          :maxLength="2000"
                          id="cuttingDock_autoSendStockCode_textarea"
                          @change="handleChangeCode('autoSendStockCodeSetting')"
                          @drop="handleDrop($event, 'autoSendStockCodeSetting')"
                        ></a-textarea>
                        <div class="textarea-length">
                          {{
                            formData.autoSendStockCodeSetting.template_string
                              ?.length ?? 0
                          }}/2000
                        </div>
                      </div>
                      <div v-if="showConfig">
                        <span id="span_fofsffrbi7">{{
                          $t('cuttingDock.autoStockCode2')
                        }}</span>
                        <a-textarea
                          v-model="
                            formData.evenAutoSendStockCodeSetting
                              .template_string
                          "
                          :placeholder="
                            $t('cuttingDock.autoStockCode2PlaceHolder')
                          "
                          :maxLength="2000"
                          id="cuttingDock_autoSendStockCode_textarea"
                          @change="
                            handleChangeCode('evenAutoSendStockCodeSetting')
                          "
                          @drop="
                            handleDrop($event, 'evenAutoSendStockCodeSetting')
                          "
                        ></a-textarea>
                        <div class="textarea-length">
                          {{
                            formData.evenAutoSendStockCodeSetting
                              .template_string?.length ?? 0
                          }}/2000
                        </div>
                      </div>
                    </div>
                    <div class="text-area">
                      <div>
                        <span id="span_lig12928ur">{{
                          $t('cuttingDock.annotationCode1')
                        }}</span>
                        <span id="span_oc9s22wsd9" class="text-area-tip"
                          >（{{ $t('cuttingDock.annotationCode1Tip') }}）</span
                        >
                        <a-textarea
                          v-model="
                            formData.firstFrontAnnotationCodeSetting
                              .template_string
                          "
                          id="engraving_setting_pauseCode_textarea"
                          :placeholder="
                            $t('cuttingDock.annotationCode1Placeholder')
                          "
                          :maxLength="2000"
                          @change="
                            handleChangeCode('firstFrontAnnotationCodeSetting')
                          "
                          @drop="
                            handleDrop(
                              $event,
                              'firstFrontAnnotationCodeSetting'
                            )
                          "
                        ></a-textarea>
                        <div class="textarea-length">
                          {{
                            formData.firstFrontAnnotationCodeSetting
                              .template_string?.length ?? 0
                          }}/2000
                        </div>
                      </div>
                      <div v-if="showConfig">
                        <span id="span_g8mo5w58gg">{{
                          $t('cuttingDock.annotationCode2')
                        }}</span>
                        <span id="span_zmrnotqia3" class="text-area-tip"
                          >（{{ $t('cuttingDock.annotationCode1Tip') }}）</span
                        >
                        <a-textarea
                          v-model="
                            formData.secondFrontAnnotationCodeSetting
                              .template_string
                          "
                          id="engraving_setting_pauseCode_textarea"
                          :placeholder="
                            $t('cuttingDock.annotationCode2Placeholder')
                          "
                          :maxLength="2000"
                          @change="
                            handleChangeCode('secondFrontAnnotationCodeSetting')
                          "
                          @drop="
                            handleDrop(
                              $event,
                              'secondFrontAnnotationCodeSetting'
                            )
                          "
                        ></a-textarea>
                        <div class="textarea-length">
                          {{
                            formData.secondFrontAnnotationCodeSetting
                              .template_string?.length ?? 0
                          }}/2000
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- 暂停代码 -->
                  <div class="text-area">
                    <div>
                      <span id="span_o646wgqass"
                        >{{ $t('cuttingDock.pauseCode') }}：</span
                      >
                      <a-textarea
                        v-model="formData.pauseCodeSetting.template_string"
                        id="engraving_setting_pauseCode_textarea"
                        :placeholder="$t('cuttingDock.pauseCodePlaceHolder')"
                        :maxLength="2000"
                        @change="handleChangeCode('pauseCodeSetting')"
                        @drop="handleDrop($event, 'pauseCodeSetting')"
                      ></a-textarea>
                      <div class="textarea-length">
                        {{
                          formData.pauseCodeSetting.template_string?.length ??
                          0
                        }}/2000
                      </div>
                    </div>
                  </div>
                  <div id="operation-starting">
                    <span
                      id="span_nw84yfkrno"
                      class="head-title code-content-title"
                      >{{ $t('cuttingDock.stationStart') }}</span
                    >
                    <div class="text-area">
                      <div>
                        <span id="span_b8kjk1bojc"
                          >{{ $t('cuttingDock.stationStartCode1') }}：</span
                        >
                        <a-textarea
                          v-model="formData.oddBeginCodeSetting.template_string"
                          id="engraving_setting_oddBeginCode_textarea"
                          :placeholder="
                            $t('cuttingDock.stationStartCode1Placeholder')
                          "
                          :maxLength="2000"
                          @change="handleChangeCode('oddBeginCodeSetting')"
                          @drop="handleDrop($event, 'oddBeginCodeSetting')"
                        ></a-textarea>
                        <div class="textarea-length">
                          {{
                            formData.oddBeginCodeSetting.template_string
                              ?.length ?? 0
                          }}/2000
                        </div>
                      </div>
                      <div v-if="showConfig">
                        <span id="span_gdrxu7rfeu"
                          >{{ $t('cuttingDock.stationStartCode2') }}：</span
                        >
                        <a-textarea
                          v-model="
                            formData.evenBeginCodeSetting.template_string
                          "
                          id="engraving_setting_evenBeginCode_textarea"
                          :placeholder="
                            $t('cuttingDock.stationStartCode2Placeholder')
                          "
                          :maxLength="2000"
                          @change="handleChangeCode('evenBeginCodeSetting')"
                          @drop="handleDrop($event, 'evenBeginCodeSetting')"
                        ></a-textarea>
                        <div class="textarea-length">
                          {{
                            formData.evenBeginCodeSetting.template_string
                              ?.length ?? 0
                          }}/2000
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="both-sides-starting">
                    <span
                      id="span_6e1sjqn3b9"
                      class="head-title code-content-title"
                      >{{ $t('cuttingDock.frontBackStart') }}</span
                    >
                    <div class="text-area">
                      <div>
                        <span id="span_i78he06hac"
                          >{{ $t('cuttingDock.frontStartCode') }}：</span
                        >
                        <a-textarea
                          v-model="formData.beginCodeFSetting.template_string"
                          id="engraving_setting_beginCodeF_textarea"
                          :placeholder="
                            $t('cuttingDock.frontStartCodePlaceholder')
                          "
                          :maxLength="2000"
                          @change="handleChangeCode('beginCodeFSetting')"
                          @drop="handleDrop($event, 'beginCodeFSetting')"
                        ></a-textarea>
                        <div class="textarea-length">
                          {{
                            formData.beginCodeFSetting.template_string
                              ?.length ?? 0
                          }}/2000
                        </div>
                      </div>
                      <div>
                        <span id="span_jp8oog0msx"
                          >{{ $t('cuttingDock.backStartCode') }}：</span
                        >
                        <a-textarea
                          v-model="formData.beginCodeBSetting.template_string"
                          id="engraving_setting_beginCodeB_textarea"
                          :placeholder="
                            $t('cuttingDock.backStartCodePlaceholder')
                          "
                          :maxLength="2000"
                          @change="handleChangeCode('beginCodeBSetting')"
                          @drop="handleDrop($event, 'beginCodeBSetting')"
                        ></a-textarea>
                        <div class="textarea-length">
                          {{
                            formData.beginCodeBSetting.template_string
                              ?.length ?? 0
                          }}/2000
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="both-sides-ending">
                    <span
                      id="span_rj1va4qmwc"
                      class="head-title code-content-title"
                      >{{ $t('cuttingDock.frontBackEnd') }}</span
                    >
                    <div class="text-area">
                      <div>
                        <span id="span_y2hn69pnvo"
                          >{{ $t('cuttingDock.frontEndCode') }}：</span
                        >
                        <a-textarea
                          v-model="formData.endCodeFSetting.template_string"
                          id="engraving_setting_endCodeF_textarea"
                          :placeholder="
                            $t('cuttingDock.frontEndCodePlaceholder')
                          "
                          :maxLength="2000"
                          @change="handleChangeCode('endCodeFSetting')"
                          @drop="handleDrop($event, 'endCodeFSetting')"
                        ></a-textarea>
                        <div class="textarea-length">
                          {{
                            formData.endCodeFSetting.template_string?.length ??
                            0
                          }}/2000
                        </div>
                      </div>
                      <div>
                        <span id="span_n5x7j9s0qt"
                          >{{ $t('cuttingDock.backEndCode') }}：</span
                        >
                        <a-textarea
                          v-model="formData.endCodeBSetting.template_string"
                          id="engraving_setting_endCodeB_textarea"
                          :placeholder="
                            $t('cuttingDock.backEndCodePlaceholder')
                          "
                          :maxLength="2000"
                          @change="handleChangeCode('endCodeBSetting')"
                          @drop="handleDrop($event, 'endCodeBSetting')"
                        ></a-textarea>
                        <div class="textarea-length">
                          {{
                            formData.endCodeBSetting.template_string?.length ??
                            0
                          }}/2000
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="plank-turn-over">
                    <span
                      id="span_jlbm8ggw1i"
                      class="head-title code-content-title"
                      >{{ $t('common.roll') }}</span
                    >
                    <div class="text-area">
                      <div>
                        <span id="span_ztadqemqed"
                          >{{ $t('cuttingDock.plankRollCode1') }}：</span
                        >
                        <a-textarea
                          v-model="formData.rollCodeSetting.template_string"
                          id="engraving_setting_rollCode_textarea"
                          :placeholder="
                            $t('cuttingDock.plankRollCode1Placeholder')
                          "
                          :maxLength="2000"
                          @change="handleChangeCode('rollCodeSetting')"
                          @drop="handleDrop($event, 'rollCodeSetting')"
                        ></a-textarea>
                        <div class="textarea-length">
                          {{
                            formData.rollCodeSetting.template_string?.length ??
                            0
                          }}/2000
                        </div>
                      </div>
                      <div v-if="showConfig">
                        <span id="span_ehjqf886n5"
                          >{{ $t('cuttingDock.plankRollCode2') }}：</span
                        >
                        <a-textarea
                          v-model="formData.evenRollCodeSetting.template_string"
                          id="engraving_setting_evenRollCode_textarea"
                          :placeholder="
                            $t('cuttingDock.plankRollCode2Placeholder')
                          "
                          :maxLength="2000"
                          @change="handleChangeCode('evenRollCodeSetting')"
                          @drop="handleDrop($event, 'evenRollCodeSetting')"
                        ></a-textarea>
                        <div class="textarea-length">
                          {{
                            formData.evenRollCodeSetting.template_string
                              ?.length ?? 0
                          }}/2000
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="plank-auto-material">
                    <span
                      id="span_nxzgr3ukc5"
                      class="head-title code-content-title"
                      >{{ $t('cuttingDock.autoBaitingCode') }}</span
                    >
                    <div class="text-area">
                      <div>
                        <span id="span_dv0c1qmjb4"
                          >{{ $t('cuttingDock.autoBaitingCode1') }}：</span
                        >
                        <a-textarea
                          v-model="
                            formData.oddAutoBaitingCodeSetting.template_string
                          "
                          id="engraving_setting_oddAutoBaitingCode_textarea"
                          :placeholder="
                            $t('cuttingDock.autoBaitingCode1Placeholder')
                          "
                          :max-length="2000"
                          @change="
                            handleChangeCode('oddAutoBaitingCodeSetting')
                          "
                          @drop="
                            handleDrop($event, 'oddAutoBaitingCodeSetting')
                          "
                        ></a-textarea>
                        <div class="textarea-length">
                          {{
                            formData.oddAutoBaitingCodeSetting.template_string
                              ?.length ?? 0
                          }}/2000
                        </div>
                      </div>
                      <div v-if="showConfig">
                        <span id="span_1dii777cbz"
                          >{{ $t('cuttingDock.autoBaitingCode2') }}：</span
                        >
                        <a-textarea
                          v-model="
                            formData.evenAutoBaitingCodeSetting.template_string
                          "
                          id="engraving_setting_evenAutoBaitingCode_textarea"
                          :placeholder="
                            $t('cuttingDock.autoBaitingCode2Placeholder')
                          "
                          :max-length="2000"
                          @change="
                            handleChangeCode('evenAutoBaitingCodeSetting')
                          "
                          @drop="
                            handleDrop($event, 'evenAutoBaitingCodeSetting')
                          "
                        ></a-textarea>
                        <div class="textarea-length">
                          {{
                            formData.evenAutoBaitingCodeSetting.template_string
                              ?.length ?? 0
                          }}/2000
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="operation-ending">
                    <span
                      id="span_dba0b7vvu2"
                      class="head-title code-content-title"
                      >{{ $t('cuttingDock.stationEnd') }}</span
                    >
                    <div class="text-area">
                      <div>
                        <span id="span_86lek1jh3b"
                          >{{ $t('cuttingDock.stationEndCode1') }}：</span
                        >
                        <a-textarea
                          v-model="formData.oddEndCodeSetting.template_string"
                          id="engraving_setting_oddEndCode_textarea"
                          :placeholder="
                            $t('cuttingDock.stationEndCode1Placeholder')
                          "
                          :max-length="2000"
                          @change="handleChangeCode('oddEndCodeSetting')"
                          @drop="handleDrop($event, 'oddEndCodeSetting')"
                        ></a-textarea>
                        <div class="textarea-length">
                          {{
                            formData.oddEndCodeSetting.template_string
                              ?.length ?? 0
                          }}/2000
                        </div>
                      </div>
                      <div v-if="showConfig">
                        <span id="span_v7q29om1pi"
                          >{{ $t('cuttingDock.stationEndCode2') }}：</span
                        >
                        <a-textarea
                          v-model="formData.evenEndCodeSetting.template_string"
                          id="engraving_setting_evenEndCode_textarea"
                          :placeholder="
                            $t('cuttingDock.stationEndCode2Placeholder')
                          "
                          :max-length="2000"
                          @change="handleChangeCode('evenEndCodeSetting')"
                          @drop="handleDrop($event, 'evenEndCodeSetting')"
                        ></a-textarea>
                        <div class="textarea-length">
                          {{
                            formData.evenEndCodeSetting.template_string
                              ?.length ?? 0
                          }}/2000
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 数据标签池 + 厚度标识：共同吸顶，避免滚动叠层遮挡 -->
                <div class="right">
                  <div class="right-sticky-wrap">
                    <g-drag-label
                      :labelList="labelList"
                      @startDrag="handleStartDrag"
                    ></g-drag-label>
                    <div class="tag-item thick-mark">
                      <span class="thick-mark__label"
                        >{{ $t('cuttingDock.thickMark') }}：</span
                      >
                      <div class="thick-mark__list">
                        <div
                          v-for="(
                            item, index
                          ) in formData.big_plank_thickness_marking_range"
                          :key="item[webId] || index"
                          class="thick-identifier-item"
                        >
                          <div>
                            <span>{{ $t('common.thick') }}</span>
                            <a-input
                              v-model="item.min_thick"
                              class="thick-identifier-item__input"
                              suffix="mm"
                              :disabled="!hasThickMarkPermission"
                              @input="
                                handleThickMarkInput(
                                  item,
                                  'min_thick',
                                  item.min_thick
                                )
                              "
                              @blur="handleThickMarkingBlur"
                            />
                            <span class="mh5">{{ $t('lineManager.to') }}</span>
                            <a-input
                              v-model="item.max_thick"
                              class="thick-identifier-item__input"
                              suffix="mm"
                              :disabled="!hasThickMarkPermission"
                              @input="
                                handleThickMarkInput(
                                  item,
                                  'max_thick',
                                  item.max_thick
                                )
                              "
                              @blur="handleThickMarkingBlur"
                            />
                            <span class="ml10 mr5">{{
                              $t('arrangedPage.markedAs')
                            }}</span>
                            <a-textarea
                              v-model="item.thick_mark"
                              class="thick-identifier-item__textarea"
                              :disabled="!hasThickMarkPermission"
                              :auto-size="{ minRows: 1, maxRows: 4 }"
                              :max-length="5"
                              @blur="handleThickMarkingBlur"
                            />
                          </div>
                          <div class="thick-identifier-item__actions">
                            <span
                              class="add-btn"
                              :class="{
                                'add-btn--disabled': !hasThickMarkPermission,
                              }"
                              @click="handleAddThickMarking"
                              >{{ $t('common.add') }}</span
                            >
                            <span
                              class="delete-btn"
                              :class="{
                                'delete-btn--disabled': !hasThickMarkPermission,
                              }"
                              @click="handleDeleteThickMarking(index)"
                              >{{ $t('common.delete') }}</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 预启动设备 -->
              <div>
                <div class="head-title code-content-title" id="hierarchy-cut">
                  <span id="span_kee7nyqtym">{{
                    $t('cuttingDock.preStartEquipment')
                  }}</span>
                  <a-switch
                    v-model="isPre"
                    class="mh15"
                    id="engraving_setting_preStart_switch"
                    @change="handleChangeNum()"
                  />
                </div>

                <div class="text-area" v-show="isShowSecondaryCatalog || isPre">
                  <div class="preStartEquipmentContent">
                    <div>
                      <div class="preLines">
                        <p id="p_q5nsc3cn6b">
                          {{ $t('cuttingDock.firstKnifePreCode') }}
                        </p>
                        <el-input
                          v-model.number="formData.firstKnifPreStartCodeInsert"
                          oninput="value=value.replace(/[^0-9]/g,'')"
                          @change="handleChangeNum()"
                          :disabled="!isPre"
                          id="engraving_setting_firstKnifPreStartCodeInsert_input"
                        />
                        <p id="p_3jmtoedqh1">
                          {{ $t('cuttingDock.rowInsert') }}
                        </p>
                      </div>
                      <div class="preLines">
                        <p id="p_aunqst855d">
                          {{ $t('cuttingDock.secondKnifePreCode') }}
                        </p>
                        <el-input
                          v-model.number="formData.preStartCodeInsert"
                          oninput="value=value.replace(/[^0-9]/g,'')"
                          @change="handleChangeNum()"
                          :disabled="!isPre"
                          id="engraving_setting_preStartCodeInsert_input"
                        />
                        <p id="p_4y3ic6uvwx">
                          {{ $t('cuttingDock.rowInsert') }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div id="pump-suspend">
                <span id="span_v1qzd3rhrh" class="head-title code-content-title"
                  >{{ $t('cuttingDock.pumpPause')
                  }}<span
                    id="span_ovr309yi41"
                    v-if="showConfig"
                    class="ml15 fs14"
                    style="color: red; font-weight: normal"
                    >({{ $t('cuttingDock.pumpPause2Tip') }})</span
                  ></span
                >
                <div class="text-area">
                  <div>
                    <span id="span_nvljob869r"
                      >{{ $t('cuttingDock.pumpPauseCode1') }}：</span
                    >
                    <a-textarea
                      v-model="formData.oddVacuumPumpPauseCode"
                      :placeholder="$t('cuttingDock.pumpPauseCode1Placeholder')"
                      id="cuttingDock_oddvacuumPumpPauseCode"
                      :max-length="2000"
                      @dragover="handleDragOver"
                    ></a-textarea>
                    <div class="textarea-length">
                      {{ formData.oddVacuumPumpPauseCode?.length ?? 0 }}/2000
                    </div>
                  </div>
                  <div v-if="showConfig">
                    <span id="span_bsitc54k3q"
                      >{{ $t('cuttingDock.pumpPauseCode2') }}：</span
                    >
                    <a-textarea
                      v-model="formData.evenVacuumPumpPauseCode"
                      :placeholder="$t('cuttingDock.pumpPauseCode2Placeholder')"
                      id="cuttingDock_evenvacuumPumpPauseCode"
                      :max-length="2000"
                      @dragover="handleDragOver"
                    ></a-textarea>
                    <div class="textarea-length">
                      {{ formData.evenVacuumPumpPauseCode?.length ?? 0 }}/2000
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { checkUserPermissions } from '@/auth/user_function'
import AnchorNav from '@/components/anchorNav/index.vue'
import GDragLabel from '@/components/g-drag-label.vue'
import newContent from '@/components/newContent.vue'
import pageTable from '@/components/page-table'
import { USER_PERMISSION_KEY } from '@/data/auth'
import store from '@/store'
import { cuttingDockNavs } from '@/util/anchorNavData.ts'
import { translate } from '@/util/commonFun'
import { buryPointApi, genUniId, verifyInputNumber } from '@/util/commonFuncs'
import { webId } from '@/util/configure'
import {
  CUTTING_DOCK_SPEED_INPUT_MAX_LEN,
  regReplaceArcRadius,
  regReplaceAxisOffset,
  regReplaceCuttingDockInputCheck,
  regReplaceCuttingDockSpeedInput,
  regReplaceCuttingParamsDiameter,
} from '@/util/regReplace'
import { message } from 'ant-design-vue'
import { mapGetters, mapState } from 'vuex'

import { cuttingDockStationSetup } from './config/cuttingDock.config'
import {
  knifeStoreConfigList as knifeStoreConfig,
  mentaojiConfig,
} from './config/tableConfig'

export default {
  components: {
    pageTable,
    AnchorNav,
    newContent,
    GDragLabel,
    // knifeTable,
  },
  props: {
    obj: {
      type: [Array, Object],
      default: () => {},
    },
    ncExportSetting: {
      type: [Array, Object],
      default: () => ({}),
    },
    isShowSecondaryCatalog: {
      type: Boolean,
      default: false,
    },
    knifeTypeOptions: {
      type: [Array, Object],
      default: () => [],
    },
    laserEnable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      CUTTING_DOCK_SPEED_INPUT_MAX_LEN,
      // 冻结 不可修改
      tableConfig: Object.freeze(mentaojiConfig),
      isPre: false,
      formData: {
        // 设备类型
        single_double_station: '',
        // 记录刀库
        knives: [],
        /*  
        // 工位1自动上料代码
        autoSendStockCode: '',
        // 工位2自动上料代码
        evenAutoSendStockCode: '',
        // 翻面代码
        // 翻面工位1
        rollCode: '',
        // 翻面工位2
        evenRollCode: '',
        // 自动下料代码1
        oddAutoBaitingCode: '',
        // 自动下料代码2
        evenAutoBaitingCode: '',
        // 工位1开始代码
        oddBeginCode: '',
        // 工位2开始代码
        evenBeginCode: '',
        // 正面开始代码
        beginCodeF: '',
        // 反面开始代码
        endCodeF: '',
        // 正面结束代码
        beginCodeB: '',
        // 反面结束代码
        endCodeB: '',
        // 工位1结束代码
        oddEndCode: '',
        // 工位2结束代码
        evenEndCode: '',
        // 暂停代码
        pauseCode: '', 
        // 工位1正面注释代码
        first_front_annotation_code: '',
        // 工位2正面注释代码
        second_front_annotation_code: '',
        */
        // 上述结构变更
        autoSendStockCodeSetting: {
          template_string: '',
          label_ids: {},
        },
        evenAutoSendStockCodeSetting: {
          template_string: '',
          label_ids: {},
        },
        rollCodeSetting: {
          template_string: '',
          label_ids: {},
        },
        evenRollCodeSetting: {
          template_string: '',
          label_ids: {},
        },
        oddAutoBaitingCodeSetting: {
          template_string: '',
          label_ids: {},
        },
        evenAutoBaitingCodeSetting: {
          template_string: '',
          label_ids: {},
        },
        oddBeginCodeSetting: {
          template_string: '',
          label_ids: {},
        },
        evenBeginCodeSetting: {
          template_string: '',
          label_ids: {},
        },
        beginCodeFSetting: {
          template_string: '',
          label_ids: {},
        },
        beginCodeBSetting: {
          template_string: '',
          label_ids: {},
        },
        endCodeFSetting: {
          template_string: '',
          label_ids: {},
        },
        endCodeBSetting: {
          template_string: '',
          label_ids: {},
        },
        oddEndCodeSetting: {
          template_string: '',
          label_ids: {},
        },
        evenEndCodeSetting: {
          template_string: '',
          label_ids: {},
        },
        pauseCodeSetting: {
          template_string: '',
          label_ids: {},
        },
        oddBeginCodeSetting: {
          template_string: '',
          label_ids: {},
        },
        evenBeginCodeSetting: {
          template_string: '',
          label_ids: {},
        },
        firstFrontAnnotationCodeSetting: {
          template_string: '',
          label_ids: {},
        },
        secondFrontAnnotationCodeSetting: {
          template_string: '',
          label_ids: {},
        },
        //首把刀预启动指令向前插入行数
        firstKnifPreStartCodeInsert: '',
        //第二把及后面的刀预启动指令向前插入行数
        preStartCodeInsert: '',
        // 真空泵1暂停代码
        oddVacuumPumpPauseCode: '',
        // 真空泵2暂停代码
        evenVacuumPumpPauseCode: '',
        // 真空泵暂停代码
        vacuumPumpPauseCode: '',
        // 大板厚度标识范围
        big_plank_thickness_marking_range: [
          {
            min_thick: '',
            max_thick: '',
            thick_mark: '',
            [webId]: genUniId(),
          },
        ],
      },
      webId,
      // 标签池
      tagList: ['成品宽度', '成品长度', '主轴刀编号', '垂直钻编号', '侧钻编号'],
      dragWord: '',
      // 记录行索引
      rowIndex: -1,
      // 记录列索引
      columnIndex: -1,
      // 记录当前选中的行
      currentRow: {},
      navs: cuttingDockNavs,
      cuttingDockStationSetup,
      labelList: [],
    }
  },
  watch: {
    obj() {
      if (Object.keys(this.obj).length > 0) {
        let s = JSON.parse(JSON.stringify(this.obj))
        let a = []
        Object.keys(s.knives).forEach((v) => {
          a.push(s.knives[v])
        })
        s.knives = a
        let ss = ['millableHole', 'millableSlot', 'slotable', 'holeable']
        s.knives.forEach((v) => {
          v.knifePurpose = []
          ss.forEach((x) => {
            if (v[x] == true) {
              v.knifePurpose.push(x)
            }
          })
        })
        //将后端传来的-1显示为空
        if (s.firstKnifPreStartCodeInsert === -1) {
          s.firstKnifPreStartCodeInsert = ''
        }
        if (s.preStartCodeInsert === -1) {
          s.preStartCodeInsert = ''
        }
        //若参数中值不为-1且不为空，复选框为选中状态
        if (
          (s.firstKnifPreStartCodeInsert &&
            s.firstKnifPreStartCodeInsert > -1) ||
          (s.preStartCodeInsert && s.preStartCodeInsert > -1)
        ) {
          this.isPre = true
        } else {
          // 解决在通过还原参数时，没有将isPre置为false的问题
          this.isPre = false
        }
        // 将雕刻机类型保存在store中，便于其他子组件使用
        this.$store.commit(
          'equipEnvironment/changeStationType',
          s.single_double_station
        )
        this.$store.commit(
          'equipEnvironment/changeShowCode2',
          s.open_two_station_code
        )
        // 兼容旧数据：补齐大板厚度标识
        if (
          !Array.isArray(s.big_plank_thickness_marking_range) ||
          !s.big_plank_thickness_marking_range.length
        ) {
          s.big_plank_thickness_marking_range = [
            {
              min_thick: '',
              max_thick: '',
              thick_mark: '',
              [webId]: genUniId(),
            },
          ]
        } else {
          s.big_plank_thickness_marking_range.forEach((item) => {
            if (!item[webId]) {
              item[webId] = genUniId()
            }
          })
        }
        this.formData = s
      }
    },
  },
  computed: {
    ...mapGetters('equipEnvironment', ['showConfig']),
    ...mapState('equipEnvironment', ['showCode2']),
    hasThickMarkPermission() {
      return (
        checkUserPermissions([USER_PERMISSION_KEY.BIG_PLANK_THICK_MARK]) ===
        true
      )
    },
    container() {
      return this.$refs.wrap
    },
    // 生成表格的 key，基于列配置，避免不必要的重新渲染
    tableKey() {
      const hasObliqueDrill = this.formData.knives.some(
        (item) => item.type && item.type.includes('obliqueDrill')
      )
      const hasInnerShapeToolMatch =
        store.state.preferencesSetting.setting.inner_shape_tool_match
      return `${hasObliqueDrill}-${hasInnerShapeToolMatch}-${this.showConfig}-${this.showCode2}`
    },
    knivesColumns() {
      let knifeStoreConfigTemp = knifeStoreConfig
      // 如果未开启雕刻机加工内部异形自动选择合适刀具，则不显示length，maximum_single_depth
      if (!store.state.preferencesSetting.setting.inner_shape_tool_match) {
        const excludeProps = ['length', 'maximum_single_depth']
        knifeStoreConfigTemp = knifeStoreConfig.filter(
          (item) => !excludeProps.includes(item.props)
        )
      }
      // 如果刀具库中所有刀具都没有类型为斜钻的,则不显示轴偏移和圆弧半径
      const hasObliqueDrill = this.formData.knives.some(
        (item) => item.type && item.type.includes('obliqueDrill')
      )
      if (!hasObliqueDrill) {
        knifeStoreConfigTemp = knifeStoreConfigTemp.filter(
          (item) => !['axis_offset', 'arc_radius'].includes(item.props)
        )
      }
      if (!this.showConfig || !this.showCode2) {
        return knifeStoreConfigTemp.concat({
          label: 'cuttingDock.knives.preStartCode',
          props: 'preStartCode',
          width: 140,
          isCheck: false,
        })
      }
      return knifeStoreConfigTemp.concat([
        {
          label: 'cuttingDock.knives.startCode2',
          props: 'startCode2',
          width: 160,
          isCheck: false,
        },
        {
          label: 'cuttingDock.knives.stopCode2',
          props: 'stopCode2',
          width: 160,
          isCheck: false,
        },
        {
          label: 'cuttingDock.knives.preStartCode',
          props: 'preStartCode',
          width: 140,
          isCheck: false,
        },
      ])
    },
    labelListFlat() {
      return this.labelList.flatMap((item) => {
        return item.arr.map((v) => {
          return {
            id: v.id,
            label_name_show: v.label_name_show,
          }
        })
      })
    },
    knifeTypeOptionsList() {
      // 如果有一把激光刀，则激光刀不可选
      let laserKnife = this.formData.knives.find(
        (item) => item.type === 'laser'
      )
      let knifeTypeOptions = JSON.parse(JSON.stringify(this.knifeTypeOptions))
      knifeTypeOptions.forEach((item) => {
        if (laserKnife) {
          if (item.value === 'laser') {
            item.isDisabled = true
          } else {
            item.isDisabled = false
          }
        } else {
          item.isDisabled = false
        }
      })
      return knifeTypeOptions
    },
  },
  methods: {
    translateLang(key) {
      return translate(key)
    },
    go(selector) {
      document.querySelector(selector).scrollIntoView({ block: 'center' })
    },
    // 更改行样式
    changeStyle({ row, rowIndex }) {
      if (this.currentRow.index == rowIndex) {
        return {
          height: '54px',
          'border-top': '1px solid #EEEEEE',
          'font-size': '14px',
          color: '#000000',
          'font-weight': '400',
          background: 'rgba(24, 168, 199, 0.2)',
        }
      }
      return {
        height: '54px',
        'border-top': '1px solid #EEEEEE',
        'font-size': '14px',
        color: '#000000',
        'font-weight': '400',
      }
    },
    // 更改单元格样式
    columnStyle({ row, column, rowIndex, columnIndex }) {
      if (column.property === 'id') {
        return 'padding-left: 16px'
      }
    },
    // 更改表头单元格样式
    headerStyle({ row, column, rowIndex, columnIndex }) {
      if (column.property === 'id') {
        return 'padding-left: 16px; box-sizing: border-box;background: #fafafa'
      }
      return 'background: #fafafa'
    },
    // 更改表头行样式
    headerRowStyle({ row, rowIndex }) {
      return {
        height: '54px',
        'font-size': '14px',
        color: '#000000',
        'font-weight': '500',
        'border-bottom': 'none',
      }
    },
    // 点击单元格切换成输入框
    cellClick(row, column, cell, event) {
      if (column.property == 'id' || column.property == 'desc') {
        return
      }
      this.rowIndex = row.index
      this.columnIndex = column.index
      if (
        column.property != 'use' &&
        column.property != 'type' &&
        column.property != 'cutable'
      ) {
        this.$nextTick(() => {
          this.$refs['editInput'][0].focus()
        })
      }
    },
    // 修改表格中的值
    inputBlur(row, prop) {
      row['desc'] = row['name']
      this.rowIndex = -1
      this.columnIndex = -1
      // 失去焦点判断刀直径是否为0
      if (row['diameter'] === 0) {
        row['diameter'] = ''
      }
      if (row['diameter']) {
        row['diameter'] = Number(row['diameter'])
      }
      if (['startCode2', 'stopCode2'].includes(prop)) {
        buryPointApi(
          'equipment_dock',
          prop == 'startCode2' ? 'start_code2' : 'stop_code2'
        )
      }
    },
    // 添加刀具
    handleAddNewKnife() {
      this.formData.knives.push({
        desc: '',
        name: '',
        diameter: '',
        type: 'mill',
        cutable: false,
        use: '',
        moveZF: '',
        cutZF: '',
        moveF: '',
        cutF: '',
        startCode: '',
        startCode2: '',
        stopCode: '',
        stopCode2: '',
        preStartCode: '',
        knifePurpose: [],
        length: '',
        maximum_single_depth: '',
        axis_offset: '', // 轴偏移
        arc_radius: '', // 圆弧半径
        [webId]: genUniId(),
      })
      this.rowIndex = this.formData.knives.length - 1
      this.columnIndex = 1
      this.$nextTick(() => {
        this.$refs['editInput'][0].focus()
      })
    },
    // 删除刀具
    handleDeleteKnife() {
      if (this.formData.knives.length < 2) {
        this.$message({
          message: '刀具不能少于1个',
          type: 'error',
        })
        return
      }
      if (this.currentRow.cutable) {
        this.$message({
          message: '不能删除开料刀',
          type: 'error',
        })
        return
      }
      this.formData.knives.splice(
        this.formData.knives.findIndex((v) => v.index == this.currentRow.index),
        1
      )
    },
    // 选中刀具
    choseKnife(row, column, event) {
      this.currentRow = row
    },
    //把每一行的索引加到行数据中
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex
    },
    //把每一列的索引加到列数据中
    tableCellClassName({ column, columnIndex }) {
      column.index = columnIndex
    },
    // 只能有一把刀选中开料
    onlyOneChecked(row) {
      if (row.cutable == false) {
        this.formData.knives.forEach((v) => {
          v.cutable = false
        })
        row.cutable = true
      }
      if (row.cutable == true) {
        this.formData.knives.forEach((v) => {
          v.cutable = false
        })
        row.cutable = true
      }
    },
    // 切换刀具类型
    handleChangeKnifeType(val, row) {
      if (val === 'dill') {
        row.axis_offset = ''
        row.arc_radius = ''
        row.slotable = false
        row.millableHole = false
        row.millableSlot = false
        row.knifePurpose = row.knifePurpose.filter((item) => item == 'holeable')
      } else if (val.includes('stylingKnife')) {
        row.axis_offset = ''
        row.arc_radius = ''
        row.holeable = false
        row.slotable = false
        row.millableHole = false
        row.millableSlot = false
        row.knifePurpose = []
        buryPointApi('engraving', 'change_styling_knife_type')
      } else if (val.includes('mill')) {
        row.axis_offset = ''
        row.arc_radius = ''
      } else if (val.includes('obliqueDrill')) {
        row.holeable = false
        row.slotable = false
        row.millableHole = false
        row.millableSlot = false
        row.knifePurpose = []
        buryPointApi('engraving', 'change_oblique_drill_type')
      } else if (val === 'laser') {
        row.holeable = true
        row.slotable = true
        row.millableHole = true
        row.millableSlot = true
        row.knifePurpose = [
          'holeable',
          'slotable',
          'millableHole',
          'millableSlot',
        ]
        if (row.cutable) {
          row.cutable = false
          message.warning(
            this.$translateLang(
              '激光刀不可加工内部未切透的异形，已自动取消"开料"项勾选'
            )
          )
        }
      }
    },
    // scope.row, knife.props, knife.isCheck
    isKnifeSpeedProp(prop) {
      return ['moveZF', 'cutZF', 'moveF', 'cutF'].includes(prop)
    },
    handleInputCheck(row, prop, flag) {
      // 刀具名称不能输入特殊字符
      if (prop == 'name') {
        const regex = /[^a-zA-Z0-9_-]/
        if (regex.test(row[prop])) {
          row[prop] = row[prop].replace(regex, '').trim()
        }
      }
      row['desc'] = row['name']
      // 速度类字段：支持英文字符、空格、换行，上限 2000
      if (this.isKnifeSpeedProp(prop)) {
        row[prop] = regReplaceCuttingDockSpeedInput(row[prop])
        return
      }
      if (flag) {
        row[prop] = regReplaceCuttingDockInputCheck(row[prop])
      }
      // 刀径只能输入数字且不能为负数和0
      if (prop === 'diameter') {
        row[prop] = regReplaceCuttingParamsDiameter(row[prop])
      }
      // 轴偏移仅可输入数字、小数点、负号，保留3位整数2位小数
      if (prop === 'axis_offset') {
        row[prop] = regReplaceAxisOffset(row[prop])
      }
      // 圆弧半径仅可输入数字、小数点,保留3位整数2位小数
      if (prop === 'arc_radius') {
        row[prop] = regReplaceArcRadius(row[prop])
      }
    },
    handleChangeNum() {
      if (!this.isPre) {
        this.formData.firstKnifPreStartCodeInsert = ''
        this.formData.preStartCodeInsert = ''
      }
    },
    handleThickMarkInput(item, key, value) {
      verifyInputNumber(value, item, [key], '5-2', false, 0, false, 0, true)
    },
    handleThickMarkingInput(index) {
      const item = this.formData.big_plank_thickness_marking_range[index]
      if (item?.thick_mark?.length > 5) {
        item.thick_mark = item.thick_mark.slice(0, 5)
      }
    },
    handleThickMarkingBlur() {
      buryPointApi('engraving', 'change_thick_marking_input')
    },
    handleAddThickMarking() {
      if (!this.hasThickMarkPermission) return
      if (this.formData.big_plank_thickness_marking_range.length < 10) {
        this.formData.big_plank_thickness_marking_range.push({
          min_thick: '',
          max_thick: '',
          thick_mark: '',
          [webId]: genUniId(),
        })
      } else {
        this.$message.warning(this.$translateLang('最多添加10个'))
      }
    },
    handleDeleteThickMarking(index) {
      if (!this.hasThickMarkPermission) return
      if (this.formData.big_plank_thickness_marking_range.length <= 1) {
        this.$message.warning(this.$translateLang('不能全部删除'))
        return
      }
      this.formData.big_plank_thickness_marking_range.splice(index, 1)
    },
    // 设备类型切换
    handleChangeStationType(val) {
      // 将新值保存到store中
      const { target } = val
      this.$store.commit('equipEnvironment/changeStationType', target.value)
      // 添加埋点
      buryPointApi('engraving', 'toggle_single_double_station')
    },
    handleChangeShowCode2(e) {
      const { checked } = e.target
      this.$store.commit('equipEnvironment/changeShowCode2', checked)
      // TODO: 添加埋点
      buryPointApi('engraving', 'toggle_show_code2')
    },
    // 拖拽标签
    handleStartDrag(event, item) {
      // this.dragWord = `{${item.label_name_show}}`
      this.dragWord = `{${item}}`
      // TODO: 拖拽标签
      this.$nextTick(() => {
        event.dataTransfer.setData('Text', `{${item}}`)
      })
    },
    // 拖拽鼠标位置在输入框上时
    handleDragOver(event) {
      // 需要阻止元素的默认处理
      event.preventDefault()
    },
    // 拖拽元素到目标对象上鼠标放开时
    handleDrop($event, item) {
      setTimeout(() => {
        // 将光标的结束位置赋值给起始位置, 取消拖动之后的选中问题
        $event.target.selectionStart = $event.target.selectionEnd
      })
      buryPointApi('equipment_dock', 'select_label')
    },
    // 修改代码框需要重新生成label_ids
    handleChangeCode(key) {
      const str = this.formData[key].template_string
      let ids = {}
      for (let item of this.labelListFlat) {
        if (str.includes(`{${item.label_name_show}}`)) {
          ids[item.label_name_show] = item.id
        }
      }
      this.formData[key].label_ids = ids
    },
    // 获取开料对接部分代码框新增信息
    getDockCustomLabel() {
      this.$getByToken(
        '/get_electronic_saw_label',
        {
          label_class: 'materialDocking',
        },
        (res) => {
          const bigPlankInfo = res?.data?.big_plank_info || []
          const orderInfo = res?.data?.order_info || []
          this.labelList = [
            {
              title: '订单信息',
              arr: orderInfo,
            },
            {
              title: '大板信息',
              arr: bigPlankInfo,
            },
          ]
        }
      )
    },
  },
  mounted() {
    this.getDockCustomLabel()
  },
}
</script>

<style scoped lang="less">
@import '~@/style/engraving.less';
.disabled-btn {
  opacity: 0.6;
}
p {
  height: 42px;
  line-height: 42px;
}
.preStartEquipmentContent {
  display: flex;
}
/deep/.el-checkbox {
  height: 32px;
  margin-right: 20px;
  padding-top: 8px;
}

.cutting-dock {
  overflow: auto;
  //padding会导致滚动条的高度发生变化
  background-color: #fff;
  .wrap {
    .navRightWrapWidth();
  }

  .head-title {
    display: inline-block;
    box-sizing: border-box;
    width: 100%;
    padding: 24px;
    color: #000;
    font-weight: 600;
    font-size: 18px;
  }
  // 单双工位设置
  .station-setup {
    .second-title {
      padding-left: 24px;
    }
  }
  .knife-table {
    background: #fff;
  }
  .code-box {
    width: 100%;
    // margin: 24px auto 0 auto;
    background: #fff;
    .tag-lake {
      box-sizing: border-box;
      width: 100%;
      padding: 32px 24px 32px 24px;
      .tag-lake-title {
        display: flex;
        display: inline-block;
        align-items: center;
        box-sizing: border-box;
        width: 100%;
        padding: 11px 24px;
        background: #e9e9e9;
        span:first-child {
          margin-right: 8px;
          color: #000;
          font-weight: 600;
          font-size: 16px;
        }
      }
      .tag-list {
        box-sizing: border-box;
        width: 100%;
        padding: 24px 24px 17px 24px;
        border: 1px solid #e9e9e9;
        span {
          display: inline-block;
          width: 102px;
          height: 32px;
          margin-right: 8px;
          color: #5a5a5a;
          line-height: 32px;
          text-align: center;
          background: #eaf4f6;
          cursor: pointer;
          user-select: none;
        }
      }
    }
    .code-content {
      .code-content-title {
        // display: block;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        width: 100%;
        padding: 8px 24px 16px 24px;
        // border-bottom: 1px solid #e9e9e9;
      }
      .code-display {
        display: flex;
        .right {
          flex: 1;
          padding: 24px 16px;
          .right-sticky-wrap {
            position: sticky;
            top: 20px;
            z-index: 11;
            // 子组件自身 sticky 取消，由外层统一吸顶
            /deep/ .label-box {
              position: static;
              top: auto;
              z-index: auto;
            }
          }
          .thick-mark {
            display: flex;
            align-items: flex-start;
            margin-top: 16px;
            .thick-mark__label-wrap {
              flex-shrink: 0;
              margin-right: 4px;
            }
            .thick-mark__label {
              flex-shrink: 0;
              line-height: 32px;
              white-space: nowrap;
            }
            .thick-mark__list {
              flex: 1;
            }
            .thick-identifier-item {
              display: flex;
              flex-direction: column;
              align-items: flex-end;
              margin-bottom: 10px;
              .thick-identifier-item__input {
                width: 80px;
                margin: 0 4px;
              }
              .thick-identifier-item__textarea {
                width: 80px;
                margin: 0 4px;
                vertical-align: middle;
              }
              .thick-identifier-item__actions {
                margin-top: 8px;
              }
              .add-btn {
                margin-right: 10px;
                color: #18a8c7;
                cursor: pointer;
                &--disabled {
                  color: rgba(0, 0, 0, 0.25);
                  cursor: not-allowed;
                }
              }
              .delete-btn {
                color: #f5222d;
                cursor: pointer;
                &--disabled {
                  color: rgba(0, 0, 0, 0.25);
                  cursor: not-allowed;
                }
              }
            }
          }
        }
      }
      .text-area {
        display: flex;
        flex-wrap: wrap;
        box-sizing: border-box;
        padding: 0px 24px 0 24px;
        div {
          margin-bottom: 24px;
        }
        div:nth-child(2n + 1) {
          margin-right: 24px;
        }
        span {
          color: rgba(0, 0, 0, 0.8);
          font-weight: 600;
          cursor: default;
        }
        textarea {
          display: block;
          width: 466px;
          height: 113px;
          margin-top: 8px;
          border: 1px solid #dddddd;
          border-radius: 4px;
          resize: none;
        }
        .text-area-tip {
          font-size: 12px;
          color: #999999;
        }
      }
      .preLines {
        display: flex;
        align-items: center;
        margin-bottom: 0px;
        /deep/.el-input {
          width: 60px;
          margin-right: 6px;
          margin-bottom: 12px;
          margin-left: 6px;
          input {
            text-align: center;
          }
        }
      }
    }
  }
}
.knife-table {
  .changeKnifeCodeCheckbox {
    display: flex;
    padding-left: 24px;
    .text {
      margin-right: 5px;
    }
  }
  .main-table {
    box-sizing: border-box;
    // max-height: 407px;
    padding: 24px;
    /deep/.el-table {
      &::before {
        background: transparent;
      }
      .has-gutter tr {
        background-color: #fafafa;
      }
      .el-table__cell.gutter {
        background-color: rgb(250, 250, 250);
      }
      .hidden-columns {
        display: none;
      }
      .el-table__body-wrapper {
        // max-height: 340px;
        // overflow: scroll;
        // &::-webkit-scrollbar {
        //   display: none;
        // }
      }
      .knives_type {
        .icon-revise-show {
          display: none;
        }
        &:hover .icon-revise-show {
          display: inline-block;
        }
      }
    }
    .knife-header {
      display: flex;
      align-items: center;
      flex-wrap: nowrap;
      span {
        margin: 0 2px;
        white-space: nowrap;
      }
    }
  }
  .operation-btn {
    box-sizing: border-box;
    padding: 0 24px 0 24px;
    .danger-btn {
      color: #ff4d4f;
      &.ant-btn {
        border-color: #ff4d4f;
      }
    }
  }
  .sawCheckbox-wrap {
    margin-left: 24px;
  }
  .knife-purpose {
    display: flex;
    flex-wrap: wrap;
    /deep/.ant-checkbox-wrapper {
      margin-left: 0;
      &:nth-child(3) {
        margin-right: 8px;
      }
    }
    /deep/.ant-checkbox + span {
      padding-right: 0;
    }
  }
}
.custom-color {
  color: #8c8c8c;
}
.feeding-tips {
  color: red;
}
.textarea-length {
  text-align: right;
  margin: 0 !important;
  /deep/ .ant-radio-wrapper {
    width: 100% !important;
    text-align: left !important;
  }
}
#engraving_setting_mentaoji_saws_saw_direction_radio,
#engraving_setting_mentaoji_saws_cut_from_radio {
  line-height: 0.5;
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
}
.toast-span {
  color: red;
}
</style>
